export default {
    SET_NOTES(state, notes) {
        state.notes = notes
    },

    SET_TOTAL_NOTES(state, totalNotes) {
        state.totalNotes = totalNotes
    },

    SET_ACTIVE_NOTE(state, activeNote) {
        state.activeNote = activeNote
    },

    SET_NOTE_HISTORY(state, changes) {
        state.noteHistory = changes
    },

    SET_TOTAL_CHANGES(state, totalChanges) {
        state.totalChanges = totalChanges
    },
    SET_IS_LOADING(state, loading) {
        state.isLoading = loading
    },
}
